export default class BlobHelper {
    public static CreateBlob(base64String: string, type: string): Blob {
        const rawData = atob(base64String);
        const bytes = new Array(rawData.length);

        for (let x = 0; x < rawData.length; x++) {
            bytes[x] = rawData.charCodeAt(x);
        }

        const arr = new Uint8Array(bytes);

        return new Blob([arr], { type: type });
    }
}